import React, { forwardRef } from 'react';
import { InputOTP, InputOTPGroup, InputOTPSeparator, InputOTPSlot } from '../shadcn/ui/input-otp';

type Props = {
  onChange: (value: string) => void; // Updated type for clarity
  value?: string;
};

// Use forwardRef correctly with the InputOTP component
export const InputOTPDemo = forwardRef<HTMLInputElement, Props>(({ onChange, value }, ref) => {
  return (
    <InputOTP
      ref={ref}
      value={value}
      onChange={onChange}
      maxLength={6}
      className="flex justify-center items-center"
    >
      <InputOTPGroup className="flex gap-2">
        <InputOTPSlot
          index={0}
          className="w-12 h-12 text-lg text-black cursor-pointer font-medium text-center border  border-gray-300 rounded-md bg-white shadow-sm focus:border-[#c00d10] focus:ring-2 focus:ring-[#c00d10] focus:ring-opacity-50 transition-all"
        />
        <InputOTPSlot
          index={1}
          className="w-12 h-12 text-lg text-black cursor-pointer font-medium text-center border border-gray-300 rounded-md bg-white shadow-sm focus:border-[#c00d10] focus:ring-2 focus:ring-[#c00d10] focus:ring-opacity-50 transition-all"
        />
        <InputOTPSlot
          index={2}
          className="w-12 h-12 text-lg text-black cursor-pointer font-medium text-center border border-gray-300 rounded-md bg-white shadow-sm focus:border-[#c00d10] focus:ring-2 focus:ring-[#c00d10] focus:ring-opacity-50 transition-all"
        />
      </InputOTPGroup>
      <InputOTPSeparator className="text-[#c00d10] mx-2 text-2xl font-bold" />
      <InputOTPGroup className="flex gap-2">
        <InputOTPSlot
          index={3}
          className="w-12 h-12 text-lg text-black cursor-pointer font-medium text-center border border-gray-300 rounded-md bg-white shadow-sm focus:border-[#c00d10] focus:ring-2 focus:ring-[#c00d10] focus:ring-opacity-50 transition-all"
        />
        <InputOTPSlot
          index={4}
          className="w-12 h-12 text-lg text-black cursor-pointer font-medium text-center border border-gray-300 rounded-md bg-white shadow-sm focus:border-[#c00d10] focus:ring-2 focus:ring-[#c00d10] focus:ring-opacity-50 transition-all"
        />
        <InputOTPSlot
          index={5}
          className="w-12 h-12 text-lg text-black cursor-pointer font-medium text-center border border-gray-300 rounded-md bg-white shadow-sm focus:border-[#c00d10] focus:ring-2 focus:ring-[#c00d10] focus:ring-opacity-50 transition-all"
        />
      </InputOTPGroup>
    </InputOTP>
  );
});

InputOTPDemo.displayName = 'InputOTPDemo'; // For React DevTools